var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3967465,22.1185746 L28.8587779,27.6419607 L27.3798044,29.1045055 L21.9088083,23.572054 C19.9135049,25.2002379 17.3661051,26.1775003 14.5904502,26.1799998 C8.18901975,26.18 3,20.9909803 3,14.59 C3,8.18901975 8.18901975,3 14.59,3 C20.9909803,3 26.18,8.18901975 26.1799998,14.5904502 C26.1774119,17.464342 25.1298417,20.0935359 23.3967465,22.1185746 Z M23.1,15.26 L22.1,15.26 C22.1,11.1178644 18.7421356,7.76 14.6,7.76 L14.6,6.76 C19.2944204,6.76 23.1,10.5655796 23.1,15.26 Z M14.59,5.09 C9.34329488,5.09 5.09,9.34329488 5.09,14.59 C5.09,19.8367051 9.34329488,24.09 14.59,24.09 C19.8367051,24.09 24.09,19.8367051 24.09,14.59 C24.09,12.0704433 23.08911,9.65408117 21.3075144,7.87248558 C19.5259188,6.09088998 17.1095567,5.09 14.59,5.09 Z",
    fill: "#31549B",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_search.c4b7dcbe.svg";
export { ForwardRef as ReactComponent };